<template>
	<div class="conversation-head-box">
		<div class="max-reception">
			<label>最大接待：</label>
			<el-select v-model="maxReception" :disabled="isIMType($store.state.currentShop.serviceType)" placeholder="-">
				<el-option v-for="obj in maxReceptionArr" :key="obj.val" :label="obj.label" :value="obj.val"></el-option>
			</el-select>
		</div>
		<div class="conversation-sort">
			<label v-show="showSortBtn" class="js-conversation-sort-btn" @click="$store.commit('changeShowSortBox', true)">排序</label>
			<ul v-show="$store.state.showSortBox">
				<li :class="{active: sortType == 'startTime'}" @click="switchConversationSort('startTime')">按进入时间排序</li>
				<li :class="{active: sortType == 'lastActive'}" @click="switchConversationSort('lastActive')">按等待时间排序</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'conversationHead',
	data () {
		return {
			maxReception: '',
			maxReceptionArr: [
				{
					val: '',
					label: '-'
				},
				{
					val: '5',
					label: '5'
				},
				{
					val: '10',
					label: '10'
				},
				{
					val: '15',
					label: '15'
				},
				{
					val: '20',
					label: '20'
				}
			],
			showSortBtn: true,
			searchResult: null
		}
	},
	props: ['sortType'],
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		conversationType () {
			return this.$store.state.conversationType;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id || !now.id) return;
				this.getMaxReception();
				// this.$emit('changeSort', 'startTime');
			}
		},
		conversationType () {
			// this.$emit('changeSort', 'startTime');
			this.showSortBtn = !this.conversationType
		},
		maxReception () {
			// 添加一个searchResult变量，防止因切换店铺改变maxReception值从而引起调用self.setMaxReception()方法
			if (this.searchResult !== this.maxReception) {
				this.setMaxReception();
			}
			this.searchResult = null;
		}
	},
	mounted () {
		this.getMaxReception();
	},
	methods: {
		// 判断店铺类型是否属于IM类型
		isIMType (type) {
			return TJ_IM.isIMType(type)
		},

		// 查询最大接待数
		getMaxReception () {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					shopId: self.currentShop.id
				};

			if (!data.shopId) return;
			self.searchResult = '';
			self.maxReception = '';
			self.$axios.post(API_ROOT.url + '/CustomerStatusApi.getMaxServiceCount', data).then(result => {
				if (result.status) {
					self.searchResult = result.data;
					self.maxReception = result.data;
				}
			});
		},

		// 设置最大接待数
		setMaxReception () {
			var self = this,
				data = {
					shopId: self.currentShop.id,
					maxSessionCount: self.maxReception
				};

			if (!data.shopId) return;
			self.$axios.post(API_ROOT.baseUrl + '/CustomerSettingApi.customerSetting', data).then(result => {
				if (!result.status) {
					self.$alert('设置最大接待数失败，错误原因：' + result.msg);
				}
			}, response => {
				self.$alert('设置最大接待数失败，错误码(' + response + ')');
			});
		},

		// 切换会话列表排序类型
		switchConversationSort (type) {
			var self = this,
				data = {
					serviceType: self.currentShop.serviceType,
					shopId: self.currentShop.id,
					sessionOrder: type == 'startTime' ? 'asc' : 'desc',
					sortBy: type,
					closed: 0,
					uncloseable: false
				};

			localStorage.setItem('IMSort', type);

			self.$emit('changeSort', type);
			self.$store.commit('changeConversationLoadStatus', true);
			self.$store.commit('changeConversationList', []);

			/*TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + self.currentShop.id, function(arr) {
				self.$store.commit('changeConversationLoadStatus', false);
				self.$store.commit('changeConversationList', arr);
			})*/

			self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(result => {
				if (result.status) {
					self.$store.commit('changeConversationList', result.data);
				} else {
					self.$alert('切换会话列表排序类型失败，错误原因：' + result.msg);
				}
				self.$store.commit('changeConversationLoadStatus', false);
			}, response => {
				self.$alert('切换会话列表排序类型失败，错误码(' + response + ')');
				self.$store.commit('changeConversationLoadStatus', false);
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/conversation/conversationHead.vue